import React, { useState } from 'react';
import { Card, Button, Result, Radio } from 'antd';

const CompletionStep: React.FC = () => {
  const [entryPoint, setEntryPoint] = useState<'order' | 'default'>('default');

  const handleNavigateAccount = () => {
    if (window.opener) {
      window.opener.location.href = '/account';
    }
    window.close();
  };

  const renderButtons = () => {
    if (entryPoint === 'order') {
      return [
        <Button type="primary" key="center" onClick={handleNavigateAccount}>
          进入账户中心
        </Button>,
        <Button key="reorder" onClick={() => window.close()}>
          返回重新下单
        </Button>,
      ];
    }
    return [
      <Button type="primary" key="center" onClick={handleNavigateAccount}>
        进入账户中心
      </Button>,
    ];
  };

  return (
    <Card className="enterprise-step-card enterprise-fade-in" style={{ width: '800px', margin: '0 auto', position: 'relative' }}>
      <div style={{ position: 'absolute', top: 20, right: 20, zIndex: 10 }}>
        <Radio.Group value={entryPoint} onChange={(e: any) => setEntryPoint(e.target.value)} optionType="button" buttonStyle="solid" size="small">
          <Radio.Button value="default">默认入口</Radio.Button>
          <Radio.Button value="order">下单页入口</Radio.Button>
        </Radio.Group>
      </div>
      <Result
        status="success"
        title="账户开立完成！"
        subTitle="恭喜您，会员开立、登记簿开立和银行卡绑定全部完成，现在可以使用账户中心的所有功能。"
        extra={renderButtons()}
      />
    </Card>
  );
};

export default CompletionStep;